<template>
  <div>
    <template v-if="_.trim(opportunityId) === ''">
      {{ opportunityName }}
    </template>
    <template v-else>
      <a class="link" target="_blank" :href="safeUrl(`${ $root.salesforceUrl }/${ opportunityId }`)">{{ opportunityName }}</a>
      <!--
        <a v-if="sfdcSearchOnFtieEnabled" class="link" target="_blank" :href="`${ frontEndUrlToUse }opportunity/opty-id/${opportunityId}`">{{ opportunityName }}</a>
        <a v-else class="link" target="_blank" :href="`${ $root.salesforceUrl }/${ opportunityId }`">{{ opportunityName }}</a>
  -->

    </template>
  </div>
</template>
<script>
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    name: 'gtc-account-link',
    props: ['opportunityId', 'opportunityName'],
    data() {
      return {
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        searching: false,
        userFunctions: null,
        userRoles: null,
        userSites: null,
        login_user_name: null,
      }
    },
    created() {
      let self = this;
      self.checkLoggedIn();
      // self.sfdcSearchEnabled();
    },
    methods: {
      sfdcSearchOnFtieEnabled() {
        let self = this;
        if ((self.userRoles && (_.indexOf(self.userRoles, 'Admin') > -1 || (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 && self.userSites && _.indexOf(self.userSites, 'Getac') > -1)) || (self.userFunctions && _.indexOf(self.userFunctions, 'Customer Success Manager') > -1))
        ) {
          console.log("Search Enabled!!");
          return true
        }
        if (((self.userSites && _.indexOf(self.userSites, 'GUSA') > -1 && self.userRoles && _.indexOf(self.userRoles, 'GRO_SA') > -1) && self.userRoles && (_.indexOf(self.userRoles, 'GRO_SA_Leader') > -1 || _.indexOf(self.userRoles, 'GRO_SA') > -1))) {
          console.log("Search Enabled!!");
          return true
        }
        console.log("Search Disabled!!");
        return false;
      },

      checkLoggedIn() {
      if (!this.$session.has('user_name')) {
        this.$router.push("/");
      }
      console.log("this.$session.has('user_name')");
      console.log(this.$session.has('user_name'));
      var user_name = this.$session.get('user_name');
      var options = this.$session.get('options');
      var user_email = this.$session.get('user_id');
      var user_functions = this.$session.get('user_functions');
      var user_roles = this.$session.get('user_roles');
      var user_site = this.$session.get('user_site');

      /*
      console.log("this.$session.get('options')");
      console.log(options);
      console.log(options.model_list);
      console.log("login_user_name:");
      console.log(user_name);
      console.log("user_email:");
      console.log(user_email);
      console.log("user_functions:");
      console.log(user_functions);
      console.log("user_roles:");
      console.log(user_roles);
      console.log("user_site:");
      console.log(user_site);
      */


      this.login_user_name = user_name
      this.userFunctions = user_functions;
      this.userRoles = user_roles;
      this.userSites = user_site;
     }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/framework/GtcAccountLink.vue